import { Injectable, InjectionToken, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { PROTECTED_FALLBACK_PAGE_URI, PUBLIC_FALLBACK_PAGE_URI } from 'ngx-auth';

import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    @Inject(PROTECTED_FALLBACK_PAGE_URI) private protectedFallbackUri: string,
    @Inject(PUBLIC_FALLBACK_PAGE_URI) private publicFallbackUri: string
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.getAccessToken().pipe(
      switchMap(accessToken => {
        if (accessToken) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`
            }
          });
        }

        return next.handle(request).pipe(
          catchError(error => {
            if (error.status === 401) {
              // Handle unauthorized error
              // Redirect to appropriate page based on ngx-auth fallback values
              
              if (!window.location.href.includes(this.publicFallbackUri)) {
              window.location.href = this.publicFallbackUri;  
              }
              
            }
            return throwError(error);
          })
        );
      })
    );
  }
}
